// extracted by mini-css-extract-plugin
export default {"wrapper":"TopUpSepa_wrapper__2ahZ5","text":"TopUpSepa_text__PZ3yd","number":"TopUpSepa_number__ATiZJ"};